import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import surah from '../db/surah.json'

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props => (
        surah.some(s => s.surat_name.toLowerCase().replace(' ', '-').replace(`'`, '') === props.match.url.replace('/', '')) ?
          (
            <Component {...props} />
          ) : (
            <Redirect to="/404" />
          )
      )
      }
    />
  )
}

export default PrivateRoute